import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { SettingsService } from '../../../shared/services/settings.service';
import { ITdDataTableColumn, TdDialogService, ITdDataTableSortChangeEvent, TdDataTableSortingOrder, IPageChangeEvent, TdDataTableService } from '@covalent/core';
import { Branch } from '../branch';
import { Observable } from 'rxjs/Observable';
import { Customer } from '../customer';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { HttpInterceptorService } from '@covalent/http';
import { Bank } from '../bank';
import { Payment } from '../payment';
import { PaymentInvoice } from '../payment-invoice';
import { Subscription } from 'rxjs/Subscription';
import { BankService } from '../../../shared/services/bank.service';
import { ChequeService } from '../../../shared/services/cheque.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BranchService } from '../branches/branch.service';
import { CustomerService } from '../customer/customer.service';
import { AccountingService } from '../accounting.service';

import { Utils } from '../../../shared/utils';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  providers: [InvoiceService, BankService, ChequeService, AccountingService, CustomerService]
})
export class PaymentComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();

  allBranches$: Observable<Branch[]>;
  allAccounts$: Observable<Bank[]>;


  branch_id: number;
  account_id: number;
  //customer_id: number;
  customer: Customer;
  currency: string;
  payment_date: string;// = new Date().toISOString().substr(0, 10);
  maturity_date: string;// = new Date().toISOString().substr(0, 10);
  cheque_number: string;
  endorsement: string;
  _creating: boolean = false;

  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  columns_outstanding: ITdDataTableColumn[] = [
    { name: 'id', label: 'Invoice #' },
    { name: 'date', label: 'Date' },
    { name: 'due_date', label: 'Due Date' },
    { name: 'total', label: 'Total amount' },
    { name: 'outstanding', label: 'Outstanding amount' },
    { name: 'cheques', label: 'Cheques' }
  ];

  columns_payable: ITdDataTableColumn[] = [
    { name: 'id', label: 'Invoice #' },
    { name: 'date', label: 'Date' },
    { name: 'total', label: 'Total amount' },
    { name: 'paid', label: 'Paid amount' },
    { name: 'discount', label: 'Discount amount' },
    { name: 'outstanding', label: 'Outstanding amount' },
  ];

  outstandingInvoices: any[];
  payableInvoices: any[] = [];

  filteredData: any[];
  filteredTotal: number;
  payableTotal: number;

  fromRow: number = 1;
  currentPage: number = 1;
  searchTerm: string;
  sortBy: string = 'id';
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;

  transaction_status: string[] = [];
  confirmation_length: number = 0;

  bank_id_to_currency: { bank_id: number, currency: string }[] = [];
  customer_id_to_name: { customer_id: number, name: string }[] = [];
  branch_id_to_currency: { branch_id: number, currency: string, exchange_rate_euro: number }[] = [];

  constructor(public _settingsService: SettingsService,
    private _invoiceService: InvoiceService,
    private _customerService: CustomerService,
    private _bankService: BankService,
    private _chequeService: ChequeService,
    private _accountingService: AccountingService,
    private _branchService: BranchService,
    private _dataTableService: TdDataTableService,
    private _location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private _dialogService: TdDialogService) { }

  ngOnInit() {
    this.allBranches$ = this._branchService.getBranches().do(
      (branches: Branch[]) => {
        branches.forEach(
          (b: Branch) => {
            this.branch_id_to_currency.push({ branch_id: b.id, currency: b.currency, exchange_rate_euro: b.exchange_rate_euro });
          }
        );
      }
    );

    this.subscription.add(
      this._customerService
        .getCustomers()
        .subscribe((customers: Customer[]) => {
          this.allCustomers = customers;
          this.matchingCustomers = customers.slice(0, 100);

          //this._loadingService.resolve('loading');
        })
    );


    this.allAccounts$ = this._bankService.getBanks(true).do(
      (banks: Bank[]) => {
        banks.forEach(
          (b: Bank) => {
            this.bank_id_to_currency.push({ bank_id: b.id, currency: b.currency });
          }
        );
      }
    );

    this.route.paramMap.subscribe(
      (param: ParamMap) => {
        this._invoiceService.getOneInvoice(param.get('id')).subscribe(
          response => {
            if (response && Array.isArray(response) && response.length > 0) {
              this.branch_id = Number.parseInt(response[0].branch_id + '');

              this.subscription.add(
                this._customerService.
                  getOneCustomer(response[0].customer_id.toString())
                  .subscribe((customer: Customer) => {
                    this.customer = customer;
                    this.cust = this.customer.prefix + ' - ' + this.customer.name;
                    this.loadOutstanding(Number.parseInt(this.customer.id + ''));
                  }, 
                  error => {
                    this._dialogService.openAlert({
                      title: 'Error',
                      message: 'Error loading customer ID: ' + response[0].customer_id.toString()
                    });
                  })
              );

              //this.customer_id = Number.parseInt(response[0].customer_id + '');
              //this.cust = response[0].customer_prefix + ' - ' + response[0].customer_name;

              //this.loadOutstanding(this.customer_id);
              
            }
          }
        );
      }
    )
  }

  ngOnDestroy() {
    console.log('unsubscribing');

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setSelected(customer: Customer) {
    console.log(customer);
    this.customer = customer;

    //this.customer_id = Number.parseInt(customer.id);
    
    this.loadOutstanding(Number.parseInt(customer.id));
  }

  // Filter based on user input
  filterCustomer(input: string) {
    console.log('input: ' + input);

    this.matchingCustomers = this.allCustomers.filter(
      (cust: Customer) => {
        let full_name = cust.prefix + ' - ' + cust.name;
        return full_name.toLowerCase().includes(input.toLowerCase());
      }
    ).slice(0, 100); // limit the matches to 100
  }

  reportStatus(status: string, prepend?: boolean) {
    if (prepend) {
      this.transaction_status.unshift(status);
    } else {
      this.transaction_status.push(status);
    }

    if (this.transaction_status.length == this.confirmation_length) {
      let len = this.transaction_status.length;

      this._dialogService.openAlert(
        {
          title: 'Result',
          // if longer than 10 only show the first 10
          message: this.transaction_status.slice(0, 10).join(', ') +
            (len > 10 ? '... and ' + (len - 10) + ' more' : '')
        }
      ).afterClosed().subscribe(
        result => {
          this.router.navigate(['/accounting', 'invoices']);
        });
    }
  }

  payment(payment: Payment, invoices: PaymentInvoice[]) {


    this._accountingService.createPayment(payment).subscribe(
      response => {
        console.log("results: " + response);
        let _paymentId = response['id'];

        // Set the payment ID to the returned value for each of the entries
        invoices.forEach(invoice => {
          invoice.payment_id = _paymentId;
        });

        this._accountingService.createPaymentInvoice(invoices).subscribe(
          response => {
            this._dialogService.openAlert({
              title: 'Success',
              message: 'Payment ID: ' + _paymentId + ' and ' + response.length + ' Payment Invoice entries created.'
            });
          },
          error => {
            this._dialogService.openAlert({
              title: 'Error',
              message: 'Error creating invoice payment entries for Payment ID: ' + _paymentId + ', please notify support.'
            });

          }
        );
      },
      error => {
        this._dialogService.openAlert({
          title: 'Error',
          message: 'Error creating payment, please notify support'
        });

      }
    );
  }




  pay() {

    this._creating = true;

    if (!this.payment_date) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter a Date",
        closeButton: 'OK'
      })

      this._creating = false;
      return;
    }

    // If the amount is negative, need to adjust the credits and advances
    if (this.total(this.payableInvoices, 'paid') < 0) {
      this._dialogService.openAlert({
        title: 'Invalid data',
        message: 'The amount to be paid is negative. Please adjust the amounts to be paid from each receipt'
      });

      this._creating = false;
      return;
    }

    if (this.account_id == null) {
      this._dialogService.openAlert({
        title: 'Invalid data',
        message: 'Select a bank account to deposit the money to'
      });

      this._creating = false;
      return;
    }

    if (this.account_id === 0 && (this.cheque_number == null || this.maturity_date == null)) {
      this._dialogService.openAlert({
        title: 'Invalid data',
        message: 'Cheque number and maturity date required'
      });

      this._creating = false;
      return;
    }

    // There needs to be at least one item in the payable list
    if (this.payableInvoices.length < 1) {
      this._dialogService.openAlert({
        title: 'Invalid data',
        message: 'At least one payment is required'
      });

      this._creating = false;
      return;
    }

    // this is used to track invoice entries for the overall payment
    let paymentInvoices: PaymentInvoice[] = [];

    // We will run one at least (deposit into bank, create cheque, or nothing if result is zero.)
    this.confirmation_length = 1;
    // we also do one per invoice
    this.confirmation_length += this.payableInvoices.length;

    // Figure out the situation. Use a copy of the items, not the real deal, just in case
    let payableCopy = this.payableInvoices.slice().sort((a, b) => { return (new Date(a.invoice_date) > new Date(b.invoice_date)) ? 1 : -1 });

    let invoicesPaidByCheque: { id: string, amount: number }[] = [];
    // Calculate how much of the total due is paid with advances
    let advancePayment: number = this.payableInvoices.reduce((a, b) => { return a + ((b.total - b.processed) < 0 ? (b.total - b.processed) : 0) }, 0);


    // First, the "processed" field is incremented with the paid + discount
    payableCopy.forEach(
      invoice => {
        let cash: number = invoice.processed;
        let cheque: number = invoice.cheques;

        if (this.account_id != 0) {
          // All cash, no special treatment
          cash = Number.parseFloat(invoice.processed) + Number.parseFloat(invoice.paid) + Number.parseFloat(invoice.discount)

        } else {
          // Cheques, special processing
          if (invoice.paid < 0) {

            // This is an advance invoice- we pay negative money, so all of it is cash
            cash = Number.parseFloat(invoice.processed) + Number.parseFloat(invoice.paid) + Number.parseFloat(invoice.discount)

          } else {
            /* positive invoice */

            // This is a normal invoice, we need to figure out if there is enough advance money
            if ((Number.parseFloat(invoice.paid) + advancePayment) < 0) {
              // This means that we still have room, we go cash, and we reduce the advancePAyment by that much
              cash = Number.parseFloat(invoice.processed) + Number.parseFloat(invoice.paid) + Number.parseFloat(invoice.discount);
              advancePayment += Number.parseFloat(invoice.paid);

            } else if (advancePayment == 0) {
              // We're out of buffer money, go all cheque
              cheque = Number.parseFloat(invoice.cheques) + Number.parseFloat(invoice.paid) + Number.parseFloat(invoice.discount);
              invoicesPaidByCheque.push({ id: invoice.id, amount: cheque });

            } else {
              // We got "some" buffer money, we go hybrid
              let clearByCheque: number = (Number.parseFloat(invoice.paid) + advancePayment);
              // CASH is what's left in advancePayment
              cash = Number.parseFloat(invoice.processed) - advancePayment + Number.parseFloat(invoice.discount);
              // CHEQUE is what wasn't covered by advancePayment
              cheque = Number.parseFloat(invoice.cheques) + (Number.parseFloat(invoice.paid) + advancePayment) + Number.parseFloat(invoice.discount)
              // And we're out of buffer money now
              advancePayment = 0;
              // And we'll clear once the cheque clears:
              invoicesPaidByCheque.push({ id: invoice.id, amount: cheque });

            }
          }
        }

        this._invoiceService.updateInvoice(invoice.id, cash, cheque).subscribe(
          response => {
            this.reportStatus('Invoice ' + invoice.id + ' updated');

            // Add a payment invoice entry for the new payment tracking 
            // if updating the invoice was successful
            // The amount should be the paid amount, cheques only get added when deposited

            // The discounted amount should be enetered as a separate payment invoice entry, but with type discount

            // The effective date of a Credit, should be the date the credit was granted, not the date of the 
            // payment. Need to move effective date to payment_invoice instead of the payment itself?

            /* pseudo code:

              if invoice.type == Advance
                new payment of type Advance, with Effective Date = invoice date
              else if invoice.type = Credit
                new payment of type Credit, with Effective Date = invoice date
              else if invoice.type = Invoice
                new payment of type Payment, with Effective Date = this.date
            */

            if (invoice.type == 'Advance') {
              console.log('Adding a payment invoice entry towards Advance Payment: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.paid) + ', effective date: ' + invoice.invoice_date.substring(0, 10));

              paymentInvoices.push(new PaymentInvoice(
                {
                  invoice_id: invoice.id,
                  payment_id: 0,
                  type: 'Advance',
                  amount: Number.parseFloat(invoice.paid),
                  effective_date: invoice.invoice_date.substring(0, 10)
                }
              ));

            } else if (invoice.type == 'Credit' || invoice.type == 'Return') {
              console.log('Adding a payment invoice entry towards Credit: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.paid) + ', effective date: ' + invoice.invoice_date.substring(0, 10));

              paymentInvoices.push(new PaymentInvoice(
                {
                  invoice_id: invoice.id,
                  payment_id: 0,
                  type: 'Credit',
                  amount: Number.parseFloat(invoice.paid),
                  effective_date: invoice.invoice_date.substring(0, 10)
                }
              ));


            } else if (invoice.type == 'Invoice') {
              // Adding payment Invoice entries for regular invoices
              console.log('Adding a payment invoice entry for Invoice: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.paid) + ', effective date: ' + this.payment_date);

              paymentInvoices.push(new PaymentInvoice(
                {
                  invoice_id: invoice.id,
                  payment_id: 0,
                  type: 'Payment',
                  amount: Number.parseFloat(invoice.paid),
                  effective_date: this.payment_date
                }
              ));

              /*

              This is an attempt to add different entries for the advances and credits used, but 2 problems, there doesn't appear to be accurate tracking done of the total amount, and even if it was, it's impossible to know the effective dates, since all credits are lumped together.
              
              if (advancePayment == 0) {
                // no advanced payment used
                console.log('Adding a cash payment invoice entry for Invoice: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.paid) + ', effective date: ' + this.payment_date);

                paymentInvoices.push(new PaymentInvoice(
                  {
                    invoice_id: invoice.id,
                    payment_id: 0,
                    type: 'Payment',
                    amount: Number.parseFloat(invoice.paid),
                    effective_date: this.payment_date
                  }
                ));

              } else if (advancePayment + invoice.paid <= 0) {
                // no cash used
                console.log('Adding a credit usage payment invoice entry for Invoice: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.paid) + ', effective date: ' + this.payment_date);

                paymentInvoices.push(new PaymentInvoice(
                  {
                    invoice_id: invoice.id,
                    payment_id: 0,
                    type: 'Credit',
                    amount: Number.parseFloat(invoice.paid),
                    effective_date: this.payment_date
                  }
                ));

              } else {
                // both cash and advance used

                console.log('Adding a cash payment invoice entry for Invoice: ' + invoice.id + ', amount: ' + (Number.parseFloat(invoice.paid) + advancePayment) + ', effective date: ' + this.payment_date);

                paymentInvoices.push(new PaymentInvoice(
                  {
                    invoice_id: invoice.id,
                    payment_id: 0,
                    type: 'Payment',
                    amount: Number.parseFloat(invoice.paid) + advancePayment,
                    effective_date: this.payment_date
                  }
                ));

                console.log('Adding a credit usage payment invoice entry for Invoice: ' + invoice.id + ', amount: ' +(advancePayment * -1) + ', effective date: ' + this.payment_date);

                paymentInvoices.push(new PaymentInvoice(
                  {
                    invoice_id: invoice.id,
                    payment_id: 0,
                    type: 'Credit',
                    amount: (advancePayment * -1),
                    effective_date: this.payment_date
                  }
                ));
              }
              */

            }

            // if there was a discount used, add a payment invoice entry for it
            if (Number.parseFloat(invoice.discount) > 0) {

              console.log('Adding a payment invoice entry for Dicsount: ' + invoice.id + ', amount: ' + Number.parseFloat(invoice.discount) + ', effective date: ' + this.payment_date);

              paymentInvoices.push(new PaymentInvoice(
                {
                  invoice_id: invoice.id,
                  payment_id: 0,
                  type: 'Discount',
                  amount: Number.parseFloat(invoice.discount),
                  effective_date: this.payment_date
                }
              ));
            }
          },

          error => {
            this.reportStatus('Could not update invoice ' + invoice.id);
          }
        );
      }
    );
    console.log(invoicesPaidByCheque);

    // We calculate the amount of money needed
    let amount = payableCopy.reduce((a, b) => { return Number.parseFloat(a) + Number.parseFloat(b.paid) }, 0);

    if (amount == 0) {
      //this was settled with advance payments and credits, no entry in bank or cheque
      this.reportStatus('Balance settled');

      // Enter the values into the payment tracking tables
      let payment: Payment = new Payment(
        {
          effective_date: this.payment_date,
          type: 'Credit',
          //customer_id: this.customer_id,
          customer_id: Number.parseInt(this.customer.id + ''),
          customer_name: this.customer.name,
          amount: amount,
          notes: 'Balance paid with Advances and Credits'
        }
      );

      this.payment(payment, paymentInvoices);

      return;
    }

    if (this.account_id != 0) {
      console.log('bank')
      // Then we need to enter a deposit in the bank for the total amount paid (not discounted)

      //let notes = 'Payment from customer ' + (this.customer_id_to_name.find(b => { return b.customer_id == this.customer_id }) || new Customer())['name'];
      let notes = 'Payment from customer ' + this.customer.name;

      this._bankService.deposit(
        this.account_id,
        notes,
        amount,
        this.payment_date
      ).subscribe(
        response => {
          this.reportStatus('Balance deposited into account: ' + amount);

          // Now record the payment in the new Payment Table
          let payment: Payment = new Payment(
            {
              effective_date: this.payment_date,
              type: 'Payment',
              customer_id: Number.parseInt(this.customer.id + ''),
              customer_name: this.customer.name,
              amount: amount,
              notes: notes
            }
          );

          this.payment(payment, paymentInvoices);

        }
      );
    } else {
      console.log('cheque');
      // Or create a cheque for that matter
      this._chequeService.createCheque(
        //this.customer_id,
        Number.parseInt(this.customer.id + ''),
        this.branch_id,
        amount,
        this.maturity_date,
        this.endorsement,
        this.cheque_number,
        invoicesPaidByCheque
      ).subscribe(
        response => {
          this.reportStatus('Cheque created for ' + (Math.round(amount * 100) / 100).toFixed(2));
        },
        error => {
          this.reportStatus('Could not create cheque ' + error);
        }
      );
    }
  }

  goBack() {
    this._location.back();
  }

  addItemsToPayable(items) {
    this.filteredData.forEach(
      (i) => {
        if (i.selected) {
          this.payableInvoices.push(i);
          i.selected = false;
        }
      }
    );
    this.filterPayable();
    this.filter();
  }

  /*
  filterCustomers() {
    this._customerService.getCustomersPerBranch(this.branch_id + '').subscribe(
      (response: { id: string, customers: Customer[] }) => {
        this.filteredCustomers = response.customers.filter(
          (c: Customer) => {
            return this.allCustomers.some(
              (_c: Customer) => {
                return c.id == _c.id
              }
            );
          }
        );
      }
    );
  }
  */

  loadOutstanding(customer_id: number) {
    // Stop ongoing searches
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.payableInvoices = [];

    this.subscription = this._invoiceService.getOutstandingInvoices(customer_id + '').subscribe(
      response => {
        this.outstandingInvoices = response;

        this.outstandingInvoices.forEach(
          i => {
            i.paid = i.total - i.processed;
            i.discount = 0;
          }
        );

        this.filter();
      }
    );
  }

  removeItem(id: number) {
    this.payableInvoices = this.payableInvoices.filter(function (t) { return t.id != id });
  }

  getCurrency(bank_id): string {
    if (bank_id == 0) {
      // For cheques use the branch's currency
      return (this.branch_id_to_currency.find(b => { return b.branch_id == this.branch_id }) || new Bank())['currency'];
    } else {
      return (this.bank_id_to_currency.find(b => { return b.bank_id == bank_id }) || new Bank())['currency'];
    }
  }

  total(data: any[], field: string) {
    return (data || []).reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) }, 0);
  }

  totalChecked(data: any[], field: string) {
    return (data || []).reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b['selected'] ? b[field] : 0) }, 0);
  }

  toggleSelectAll(value: boolean) {
    this.filteredData.forEach(
      function (d) {
        d.selected = value;
      }
    );
  }

  shouldSelectAll(): boolean {
    return this.filteredData.filter(
      function (d) {
        return d.selected
      }
    ).length == this.filteredData.length;
  }

  enterNewValueDialog(row: any, attr: string) {
    // this only works if the value is a number, once converted to 
    // string after changing it once, it fails
    let _value = parseFloat(row[attr]).toFixed(2);

    this._dialogService.openPrompt({
      message: 'Enter new value',
      title: 'Modify value',
      value: _value,
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        row[attr] = newValue;
      } else {
        console.log('cancelled');
      }
    });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;

    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;

    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.outstandingInvoices ? this.outstandingInvoices : [];
    newData = newData.filter((item) => { return this.payableInvoices.find((entry) => { return entry.id == item.id }) == null })
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  filterPayable() {
    let newData: any[] = this.payableInvoices;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.payableTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.payableInvoices = newData;
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/payment/payment.component.ts